// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".aZ1mAmzDvzyT0e {\n  animation: YmgrDY0XWjXFNc 3000ms cubic-bezier(0.55, 0.055, 0.675, 0.19) infinite;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  border-radius: 3px;\n}\n@media (prefers-reduced-motion: reduce) {\n  .aZ1mAmzDvzyT0e {\n    animation: none;\n  }\n}\n@keyframes YmgrDY0XWjXFNc {\n  0%,\n  33% {\n    box-shadow: 0 0 0 2px var(--ds-border-discovery, #6554c0), 0 0 0 var(--ds-border-discovery, #6554c0);\n  }\n  66%,\n  100% {\n    box-shadow: 0 0 0 2px #6554c0, 0 0 0 10px rgba(101, 84, 192, 0.01);\n  }\n}\n.DJoBeED9lhj19x:active {\n  pointer-events: none;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pulse": "aZ1mAmzDvzyT0e",
	"pulsing": "YmgrDY0XWjXFNc",
	"disableClicks": "DJoBeED9lhj19x"
};
export default ___CSS_LOADER_EXPORT___;
